import React from "react";
import { motion } from "framer-motion";
import PictureImg from "../../helpers/PictureImg";

// ---------------------------------------------------------------------------
// Why Section — Figma node 490:9460
//
// New layout (replaces old icon-card version):
//   text block (title + 2-line desc, centered, max-width 804)
//   images row (3 panels, 436:952:436 ratio, gap 24, full-bleed 24px gutter)
//
// Image assets (export from Figma, save to public/img/landing/):
//   why-1.png  ← image 59   (490:11150) — 포인트 모드 화면
//   why-2.png  ← _PAN0018 1 (490:11144) — 매장에서 서비스하는 직원
//   why-3.png  ← IMG_6476 1 (490:11146) — 태블릿으로 주문 받는 모습
//
// Panel-level image crops (size + offset) are handled entirely in SCSS
// using percentage offsets derived from the Figma px values.
// ---------------------------------------------------------------------------

const IMAGES = [
  {
    key: 1,
    src: "/img/landing/why-1.png",
    alt: "포인트 모드 화면",
  },
  {
    key: 2,
    src: "/img/landing/why-2.png",
    alt: "매장에서 고객을 응대하는 직원",
  },
  {
    key: 3,
    src: "/img/landing/why-3.png",
    alt: "태블릿 POS로 주문을 받는 모습",
  },
];

const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.3 },
  transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] },
};

export default function Why() {
  return (
    <section className="why">
      <motion.div className="why__text" {...fadeUp}>
        <h2 className="why__title">왜 그로잉세일즈일까요?</h2>
        <p className="why__desc">
          흩어져 있던 온라인과 오프라인 운영을 하나로 연결합니다.
          <br />
          고객, 재고, 마케팅이 한 화면에 모이고, 브랜드는 성장에만 집중합니다.
        </p>
      </motion.div>

      <div className="why__images">
        {IMAGES.map((img, i) => (
          <motion.div
            key={img.key}
            className={`why__image why__image--${img.key}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{
              duration: 0.6,
              delay: i * 0.1,
              ease: [0.16, 1, 0.3, 1],
            }}
          >
            <PictureImg src={img.src} alt={img.alt} loading="lazy" />
          </motion.div>
        ))}
      </div>
    </section>
  );
}
